import { ProjectActions } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'
import { commitProjectRequest } from '@storeOld/actionCreators'

import API from '@/api'
import { NotificationType, notificationActionCreators } from '../notification'

// @todo implement action
export const nextSymbol = () => {}
// export const nextSymbol =
//   () => (dispatch: Function, getState: () => AppState) => {
//     const { canvas, symbolsLibrary } = getState()
//
//     const { selectedSymbol } = canvas.symbol
//
//     const findSelectedSymbolIndex = symbolsLibrary.findIndex(
//       (symbol) => symbol.id === selectedSymbol
//     )
//
//     const nextSymbolIndex =
//       findSelectedSymbolIndex + 1 >= symbolsLibrary.length
//         ? 0
//         : findSelectedSymbolIndex + 1
//
//     const nextSymbol = symbolsLibrary[nextSymbolIndex]
//
//     dispatch({
//       type: CanvasActionTypes.SELECT_SYMBOL,
//       payload: nextSymbol.id,
//     })
//   }

// @todo implement action
export const copySelectedSymbol = () => {}
// export const copySelectedSymbol =
//   () => (_: Function, getState: () => AppState) => {
//     const { canvas, symbolsLibrary } = getState()
//
//     const selectedSymbols = [
//       {
//         id: canvas.symbol.selectedSymbol,
//         type: 'symbol',
//       },
//     ]
//
//     const items = selectedSymbols.map((item) => {
//       const symbol = symbolsLibrary.find(
//         // @ts-expect-error
//         (symbol) => symbol.id === item.id
//       ) as SymbolsLibrary
//
//       return {
//         ...item,
//         options: {
//           color: symbol.color,
//           name: symbol.name,
//           wireframe: symbol.wireframe,
//           isSymbol: true,
//           symbolId: symbol.id,
//           image: symbol.image,
//         },
//       }
//     })
//
//     encodeAndCopyToClipboard(items, 'block')
//   }

export const uploadImage =
  (file: File) => (dispatch: Function, getState: () => AppState) => {
    // @todo implement selector
    const state = getState()
    const {
      canvas: {
        symbol: { selectedSymbol },
      },
      manager: {
        meta: { id: projectId },
      },
    } = state

    return new Promise((resolve, reject) => {
      if (!selectedSymbol) {
        reject()

        return
      }

      API.Image.upload({ projectId, file })
        .then((response) => {
          dispatch(
            commitProjectRequest(
              ProjectActions.symbols.updateVisual({
                ids: [selectedSymbol],
                visual: { image: response, type: 'image' },
              })
            )
          )

          return resolve(file)
        })
        .catch((error) => {
          dispatch(
            notificationActionCreators.setNotification({
              type: NotificationType.UPLOAD_ERROR,
            })
          )

          setTimeout(() => {
            dispatch(
              notificationActionCreators.setClearNotification({
                toastContainerId: 'main',
              })
            )
          }, 3000)

          return reject(error)
        })
    })
  }

export const duplicateSymbol = () => {}
